import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useUserStore } from "@/stores";
import type { AgentRolesType } from "@/utils";
import { ROUTES } from "./routes";

interface RoleProtectedRouteProps {
  roles?: AgentRolesType[];
}

export const RoleProtectedRoute = ({ roles = [] }: RoleProtectedRouteProps) => {
  const { token, isTwoFaAuthenticated, user } = useUserStore();
  const location = useLocation();
  const isAuthenticated = Boolean(token && isTwoFaAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} replace state={{ from: location }} />;
  }

  if (roles.length > 0 && user && !roles.includes(user.role)) {
    return <Navigate to={ROUTES.login} replace />;
  }

  return <Outlet />;
};
